<template>
  <v-card class="mt-2" outlined>
    <v-container v-if="!isFeatureUnavailable">
        <v-row>
            <chat-window style="height: 77vh"
                :current-user-id="currentUserId"
                :room-id="currentRoomId"
                :rooms="rooms"
                :messages="messages[currentRoomId].items"
                :loading-rooms="loadingRooms"
                :rooms-loaded="roomsLoaded"
                :messages-loaded="messages[currentRoomId].messagesLoaded"
                :show-audio="false"
                :show-files="false"
                :show-add-room="false"

                v-on:fetch-messages="fetchMessages"
                v-on:send-message="sendMessage"></chat-window>
        </v-row>
    </v-container>
    <v-container v-else style="height: 56vh">
      <v-overlay :dark="false" v-model="isFeatureUnavailable" absolute opacity="0">
        <UnavailableFeature/>
      </v-overlay>
    </v-container>
  </v-card>
</template>

<script>
import { mapMutations } from 'vuex';
import ChatWindow from 'vue-advanced-chat';
import 'vue-advanced-chat/dist/vue-advanced-chat.css';
import gql from 'graphql-tag';
import { createMessage } from '../../../graphql/mutations';
import { listMessages } from '../../../graphql/queries';
import { onCreateMessage } from '../../../graphql/subscriptions';
import UnavailableFeature from './UnavailableFeature';

export default {
  components: {
    ChatWindow, UnavailableFeature
  },
  data() {
    return {
      currentChannels: [],

      isFeatureUnavailable: true,

      loadingRooms: true,
      roomsLoaded: false,

      rooms: [],
      listMessages: { items: [] },
      messages: {},
    };
  },
  apollo:{
    listMessages:{
      query: gql(listMessages),
      subscribeToMore: {
            document: gql(onCreateMessage),
            variables(){
              return {
                clubId: this.currentClub.id,
              }
            },
            updateQuery(previousResult,{ subscriptionData }){

              let prev = previousResult;
              let data = subscriptionData.data;

              const pos = this.rooms.map(function(r) { return r.roomId; }).indexOf(data.onCreateMessage.clubChannelId);

              if(pos == -1){
                return prev
              }

              /* eslint-disable no-console */
                console.log(data);
              /* eslint-enable no-console */
              // this will stop a duplicate message being added in the browser that made the change
              const idInListAlready = this.messages[data.onCreateMessage.clubChannelId].items.some(message => message._id === data.onCreateMessage.id)
              if (idInListAlready) {
                return prev
              }


              var timemilli = Number(data.onCreateMessage.createdAt);
              var d = new Date(timemilli);
              let newMessage={
                  _id: data.onCreateMessage.id,
                  content: data.onCreateMessage.content,
                  senderId: data.onCreateMessage.userId,
                  username: data.onCreateMessage.username,
                  date: (Number(d.getMonth())+1)+'/'+d.getDate()+'/'+d.getFullYear(),
                  timestamp: this.formatAMPM(d),
                  system: false,
                  disableReactions: true,
              }
              if(data.onCreateMessage.replyContent){
                  newMessage.replyMessage = {};
                  newMessage.replyMessage.content = data.onCreateMessage.replyContent;
              }
              const newRoom = {
                nextToken:this.messages[data.onCreateMessage.clubChannelId].nextToken,
                messagesLoaded:this.messages[data.onCreateMessage.clubChannelId].messagesLoaded,
                items: [...this.messages[data.onCreateMessage.clubChannelId].items,newMessage],
              }
              this.$set(this.messages,data.onCreateMessage.clubChannelId,newRoom);

              if(data.onCreateMessage.clubChannelId!=this.currentRoomId){
                this.rooms[pos].unreadCount = this.rooms[pos].unreadCount + 1;
              }

              this.rooms[pos].lastMessage = newMessage;

              return {
                ...prev.listMessages,
                items: prev.listMessages.items.concat([data.onCreateMessage])
              }
            }
      }
    }
  },
  computed:{
      currentUserId(){
          return this.$store.state.user.id;
      },
      currentClub(){
          return this.$store.state.clubMember.club;
      },
      currentUserLogin(){
        return this.$store.state.user.username;
      },
      currentChannel(){
        return this.$store.state.currentClubChannel;
      },
      currentRoomId(){
        return this.$store.state.clubMember.club.id+'-'+this.$store.state.currentClubChannel.id;
      },
      currentUserFullName(){
        return this.$store.state.clubMember.user.firstName+' '+this.$store.state.clubMember.user.lastName
      }
  },
  watch: {
    '$store.state.clubChannelsContributedByMe': function () {
      this.refreshList();
    },
    '$store.state.clubPublicChannels': function () {
      this.refreshList();
    },
  },
  mounted(){
    this.validateFeatureAvailable();
    if(!this.isFeatureUnavailable) {
      this.refreshList();
      setTimeout(()=>{
          for (let i = 0; i < this.rooms.length; i++) {
            this.fetchMessages({room:this.rooms[i],options:{reset:false}});
          }
      },2000);
    }
  },
  methods: {
    validateFeatureAvailable() {
      let permissions = this.$store.state.clubPermissions;
      for(let permission of permissions) {
        if(permission.clubFeature.name == 'CHAT') {
          this.isFeatureUnavailable = false;
          break;
        }
      }
    },
    refreshList() {
      this.currentChannels = [{ id: -1, name: 'GENERAL' }];
      this.$store.state.clubChannelsContributedByMe.forEach((contribution) => {
        this.currentChannels.push(contribution.clubChannel);
      });
      this.currentChannels.push.apply(this.currentChannels, this.$store.state.clubPublicChannels);
      this.refreshRoomList();
    },
    refreshRoomList(){
        const rooms = [];
        for (let i = 0; i < this.currentChannels.length; i++) {
            let roomId = this.currentClub.id+"-"+this.currentChannels[i].id;
            let roomUsers = [];
            for(let j=0; j<this.$store.state.clubMembers.length;j++){
                let clubMember = this.$store.state.clubMembers[j];
                roomUsers.push({
                    _id: clubMember.user.id,
                    username: clubMember.user.firstName+' '+clubMember.user.lastName,
                    avatar: clubMember.user.imageUrl,
                });
            }
            rooms.push({
                roomId: roomId,
                roomName: this.currentChannels[i].name,
                avatar: this.currentClub.imageUrl,
                unreadCount: 0,
                users: roomUsers,
                currentChannel: this.currentChannels[i],
                lastMessage: null,
            });
            this.$set(this.messages,roomId,{items:[],nextToken: null,messagesLoaded: false});
        }
        this.rooms = rooms;
        this.loadingRooms = false;
        this.roomsLoaded = true;
    },
    fetchMessages({ room, options }) {
        const pos = this.rooms.map(function(r) { return r.roomId; }).indexOf(room.roomId);
        if(options != undefined && options.reset){
          this.listMessages = { items:[] };
          this.rooms[pos].unreadCount = 0;
          this.channelChanged(room.currentChannel);
        }else{
          if(this.messages[room.roomId].messagesLoaded){
            return ;
          }
        }
        this.$apollo.queries.listMessages.fetchMore({
            //New variables
            variables:{
              nextToken: this.messages[room.roomId].nextToken,
              limit: 20,
              filter:{
                clubChannelId:{
                  eq: room.roomId
                },
                clubId:{
                  eq: this.currentClub.id
                }
              }
            },
            //Transform the previous result with new data
            updateQuery: (prev,{ fetchMoreResult }) => {
              const newRoom = {
                items: this.messages[room.roomId].items,
              }
              const newMessages = fetchMoreResult.listMessages.items;
              const newNextToken = fetchMoreResult.listMessages.nextToken;
              newRoom.nextToken = newNextToken;

              /* eslint-disable no-console */
                console.log(room.roomId);
                console.log(prev);
                console.log(newMessages);
                console.log(this.messages[room.roomId]);
              /* eslint-enable no-console */
              if(newNextToken==null){
                newRoom.messagesLoaded = true;
              }

              for(let i=0;i<newMessages.length;i++){
                // this will stop a duplicate message being added in the browser that made the change
                const idInListAlready = newRoom.items.some(message => message._id === newMessages[i].id)
                if (idInListAlready) { continue; }

                let d = new Date(Number(newMessages[i].createdAt));
                let newMessage={
                  _id: newMessages[i].id,
                  content: newMessages[i].content,
                  senderId: Number(newMessages[i].userId),
                  username: newMessages[i].username,
                  date: (Number(d.getMonth())+1)+'/'+d.getDate()+'/'+d.getFullYear(),
                  timestamp: this.formatAMPM(d),
                  system: false,
                  disableReactions: true,
                }
                if(newMessages[i].replyContent){
                  newMessage.replyMessage = {};
                  newMessage.replyMessage.content = newMessages[i].replyContent;
                }
                if(newRoom.items.length == 0){
                    this.rooms[pos].lastMessage = newMessage;
                }
                newRoom.items = [newMessage,...newRoom.items];
              }

              this.$set(this.messages,room.roomId,newRoom);

              return {
                listMessages:{
                  __typename: prev.listMessages.__typename,
                  items: [...newMessages, ...prev.listMessages.items],
                  nextToken: newNextToken,
                }
              }
            }
          })
    },
    sendMessage({ roomId, content, file, replyMessage, usersTag }){
        const pos = this.rooms.map(function(r) { return r.roomId; }).indexOf(roomId);
        var d = new Date();
        var crypto = require("crypto");
        let newMessage={
            _id: crypto.randomBytes(20).toString('hex'),
            content: content,
            senderId: this.currentUserId,
            username: this.currentUserFullName,
            date: (Number(d.getMonth())+1)+'/'+d.getDate()+'/'+d.getFullYear(),
            timestamp: this.formatAMPM(d),
            system: false,
            disableReactions: true,
        }
        let replyContent = '';

        if(replyMessage){
          replyContent = replyMessage.username+' - '+replyMessage.content
          newMessage.replyMessage = {};
          newMessage.replyMessage.content = replyContent
        }
        this.messages[roomId].items = [...this.messages[roomId].items,newMessage];
        this.rooms[pos].lastMessage = newMessage;
        this.$apollo.mutate({
          mutation: gql(createMessage),
          variables: {
            input:{
              clubChannelId: roomId,
              clubId: this.currentClub.id,
              content: content,
              username: this.currentUserFullName,
              createdAt: d.getTime(),
              id: newMessage._id,
              isSent: true,
              userId: this.currentUserId,
              replyContent: replyContent
            }
          },
          update(cache,{data:{createMessage}}){
              // read the data from the cache for this query
            const query = cache.readQuery({query: gql(listMessages)})

            // add our person from the mutation to the end
            query.listMessages.items.push(createMessage);

            // write the data back to the cache
            cache.writeQuery({
              query: gql(listMessages),
              data: query
            })
          }
        })
        /* eslint-disable no-console */
        console.log(file);
        console.log(usersTag);
        /* eslint-enable no-console */
    },
    formatAMPM(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
    ...mapMutations(['setCurrentClubChannel']),
    channelChanged(channelContributor) {
      this.setCurrentClubChannel(channelContributor);
    },
  },
}
</script>

<style scoped>
</style>
